import { Component, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MenuItem, SelectItem } from 'primeng/api';
import { ReplaySubject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { AppComponent } from '../../app.component';
import { CompanySetting } from '../../company-setting';
import { Contract } from '../../data-services/contract';
import { StatusData } from '../../data-services/dashboard/status';
import { Funding } from '../../data-services/dashboard/funding/funding.model';
import { Process } from '../../shared';
import { IUser } from '../../user-info';
import { IDirectReport } from '../../lookups';
import { IUserRole } from '../../user-role';
import { DRStatus } from '../../data-services/dashboard/dr-status';
import { Chart } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { Accrual } from '../../data-services/dashboard/accrual';
import moment from 'moment';
import { DashboardSettings } from '../../data-services/dashboard-settings';
import { LoggingService } from '../../shared/services/logging';
import { MessageStateService } from '../../shared/services/message-state.service';
import { CategoryService } from '../../shared/services/category.service';
//import * as ShopifyBuy from '../../../../node_modules/@shopify/buy-button-js';

@Component({
    selector: 'ef-dashboard-presenter',
    templateUrl: './dashboard-presenter.component.html',
    styleUrls: ['./dashboard-presenter.component.scss'],
    standalone: false
})
export class DashboardPresenterComponent implements OnInit {
    linea = 'Please be aware that we will be performing routine server maintenance on December 9th from 12:01-11:00am (EST). This is necessary for server performance updates.';
    lineb = 'As a result, the eFAACT Desktop and eFAACTCentral.com will be unavailable during that time frame.';
    linec = 'Thank you for being a valued customer.';

    contractGraphIsVisible: boolean;
    quickAccessIsVisible: boolean;
    myStatusIsVisible: boolean;
    adminActionsIsVisible: boolean;
    supActionsIsVisible: boolean;
    pmActionsIsVisible: boolean;
    plannedHoursGraphIsVisible: boolean;
    leaveGraphIsVisible: boolean;

    dashboardSettingsTableData: DashboardSettings[];

    private DashboardSettingsSubject = new ReplaySubject<
        Array<DashboardSettings>
    >(1);
    private _dashboardsettings: Array<DashboardSettings>;
    @Input() set dashboardSettings(value: Array<DashboardSettings>) {
        this._dashboardsettings = value;
        this.DashboardSettingsSubject.next(value);
        if (
            this._dashboardsettings.findIndex(x => x.DashboardItemID == 1) != -1
        ) {
            this.quickAccessIsVisible = this._dashboardsettings.find(
                x => x.DashboardItemID == 1
            ).IsVisible;
        }
        if (
            this._dashboardsettings.findIndex(x => x.DashboardItemID == 2) != -1
        ) {
            this.myStatusIsVisible = this._dashboardsettings.find(
                x => x.DashboardItemID == 2
            ).IsVisible;
        }
        if (
            this._dashboardsettings.findIndex(x => x.DashboardItemID == 3) != -1
        ) {
            this.adminActionsIsVisible = this._dashboardsettings.find(
                x => x.DashboardItemID == 3
            ).IsVisible;
        }
        if (
            this._dashboardsettings.findIndex(x => x.DashboardItemID == 4) != -1
        ) {
            this.supActionsIsVisible = this._dashboardsettings.find(
                x => x.DashboardItemID == 4
            ).IsVisible;
        }
        if (
            this._dashboardsettings.findIndex(x => x.DashboardItemID == 5) != -1
        ) {
            this.pmActionsIsVisible = this._dashboardsettings.find(
                x => x.DashboardItemID == 5
            ).IsVisible;
        }
        if (
            this._dashboardsettings.findIndex(x => x.DashboardItemID == 6) != -1
        ) {
            this.contractGraphIsVisible = this._dashboardsettings.find(
                x => x.DashboardItemID == 6
            ).IsVisible;
        }
        if (
            this._dashboardsettings.findIndex(x => x.DashboardItemID == 7) != -1
        ) {
            this.plannedHoursGraphIsVisible = this._dashboardsettings.find(
                x => x.DashboardItemID == 7
            ).IsVisible;
        }
        if (
            this._dashboardsettings.findIndex(x => x.DashboardItemID == 8) != -1
        ) {
            this.leaveGraphIsVisible = this._dashboardsettings.find(
                x => x.DashboardItemID == 8
            ).IsVisible;
        }
    }
    get dashboardSettings(): Array<DashboardSettings> {
        return this._dashboardsettings;
    }
    private StatusDataSubject = new ReplaySubject<Array<StatusData>>(1);
    private _statusdata: Array<StatusData>;
    contractChartTypes: { label: string; value: string }[];
    adminPlus: boolean;
    highPlannedHoursCount: boolean;
    @Input() set statusData(value: Array<StatusData>) {
        value = value.map(x => ({
            ...x,
            Process:
                this.processes.find(y => y.ProcessID == x.ProcessID) != null
                    ? this.processes.find(y => y.ProcessID == x.ProcessID)
                    : null
        }));
        value.forEach(v => {
            if (
                this.processes.findIndex(x => x.ProcessID == v.ProcessID) == -1
            ) {
                v.ProcessID = null;
            }
        });
        this._statusdata = value;
        this.StatusDataSubject.next(value);
    }
    get statusData(): Array<StatusData> {
        return this._statusdata;
    }
    hasActivity: boolean;
    private ContractsSubject = new ReplaySubject<Contract[]>(1);
    private _contracts: Contract[];
    @Input() set contracts(value: Contract[]) {
        if (value) {
            this.hasActivity = value.some(x => x.HasActivity == true);

            this.contractsSelectItem = value.map(x => ({
                label: x.ContractDesc,
                value: x.ContractListID
            }));
            if (this.hasActivity == true) {
                const filteredContracts = value.filter(
                    x => x.HasActivity == true
                );
                const filteredContractsSelectItem = filteredContracts.map(
                    x => ({
                        label: x.ContractDesc,
                        value: x.ContractListID
                    })
                );
                const initialContractsForChart = [];
                let COUNT;
                if (filteredContractsSelectItem.length > 10) {
                    COUNT = 10;
                } else {
                    COUNT = filteredContractsSelectItem.length;
                }
                for (let i = 0; i < COUNT; i++) {
                    initialContractsForChart.push(
                        filteredContractsSelectItem[i].value
                    );
                }
                if (this.contractFormGroup) {
                    this.contractFormGroup.controls['MultiContract'].patchValue(
                        initialContractsForChart
                    );
                }
            }
        }
        this._contracts = value;
        this.ContractsSubject.next(value);
    }
    get contracts(): Contract[] {
        return this._contracts;
    }

    private AnnouncementSubject = new ReplaySubject<any>(1);
    private _announcement: any;
    @Input() set announcement(value: any) {
        this._announcement = value;
        this.AnnouncementSubject.next(value);
    }
    get announcement(): any {
        return this._announcement;
    }

    private AnnouncementAdminSubject = new ReplaySubject<any>(1);
    private _announcementadmin: any;
    @Input() set announcementAdmin(value: any) {
        this._announcementadmin = value;
        this.AnnouncementAdminSubject.next(value);
    }
    get announcementAdmin(): any {
        return this._announcementadmin;
    }

    private AdminMsgSubject = new ReplaySubject<any>(1);
    private _adminmsg: any;
    @Input() set adminMsg(value: any) {
        this._adminmsg = value;
        if (value) {
            this.messages.push(value);
            // Update the service with the new message count
            this.messageStateService.setMessageCount(this.messages.length);
        }
        this.AdminMsgSubject.next(value);
    }
    get adminMsg(): any {
        return this._adminmsg;
    }

    private MgrMsgSubject = new ReplaySubject<any>(1);
    private _mgrmsg: any;
    @Input() set mgrMsg(value: any) {
        this._mgrmsg = value;
        if (value) {
            this.messages.push(value);
            // Update the service with the new message count
            this.messageStateService.setMessageCount(this.messages.length);
        }
        this.MgrMsgSubject.next(value);
    }
    get mgrMsg(): any {
        return this._mgrmsg;
    }

    private UserMsgSubject = new ReplaySubject<any>(1);
    private _usermsg: any;
    @Input() set userMsg(value: any) {
        this._usermsg = value;
        if (value) {
            this.messages.push(value);
            // Update the service with the new message count
            this.messageStateService.setMessageCount(this.messages.length);
        }
        this.UserMsgSubject.next(value);
    }
    get userMsg(): any {
        return this._usermsg;
    }

    private UserRolesSubject = new ReplaySubject<Array<IUserRole>>(1);
    private _userroles: Array<IUserRole>;
    @Input() set userRoles(value: Array<IUserRole>) {
        this._userroles = value;
        this.UserRolesSubject.next(value);
        if (
            (value.findIndex(x => x.RoleGroupID == 1) != 1 &&
                value.findIndex(x => x.RoleGroupID == 12024) != -1) ||
            (value.findIndex(x => x.RoleGroupID == 1) != 1 &&
                value.findIndex(x => x.RoleGroupID == 12025) != -1)
        ) {
            this.adminPlus = true;
        } else {
            this.adminPlus = false;
        }

        if (value.findIndex(x => x.RoleGroupID == 1) != -1) {
            this.admin = true;
        } else {
            this.admin = false;
        }
    }
    get userRoles(): Array<IUserRole> {
        return this._userroles;
    }

    private UsersSubject = new ReplaySubject<Array<IDirectReport>>(1);
    private _users: Array<IDirectReport>;
    @Input() set users(value: Array<IDirectReport>) {
        this._users = value;
        this.UsersSubject.next(value);
        value = value.filter(x => x.IsActive == true);
        this.usersSelectItem = value.map(x => ({
            label: x.EmployeeName,
            value: x.EmployeeListID
        }));
    }
    get users(): Array<IDirectReport> {
        return this._users;
    }

    private UserSubject = new ReplaySubject<IUser>(1);
    private _user: IUser;
    @Input() set user(value: IUser) {
        if (value) {
            this._user = value;
            this.UserSubject.next(value);

            // Initialize the message state service when user data is available
            if (value.userInfo && value.userInfo.EmployeeListID) {
                this.messageStateService.initializeFromStore(value.userInfo.EmployeeListID);
            }

            if (this.supGraphFormGroup) {
                this.supGraphFormGroup.controls['percent'].patchValue('75');
            }
        }
    }
    get user(): IUser {
        return this._user;
    }

    private FundingSubject = new ReplaySubject<Array<Funding>>(1);
    private _funding: Array<Funding>;
    @Input() set funding(value: Array<Funding>) {
        this._funding = value;
        this.FundingSubject.next(value);
        if (value.length == 0) {
            if (this.contractFormGroup) {
                if (
                    this.contractFormGroup.controls['percentSpent'].value !=
                        null ||
                    this.contractFormGroup.controls['Contract'].value != null
                ) {
                    this.showContractsGraph = true;
                } else {
                    this.showContractsGraph = false;
                }
            }
        }
        if (value && value.length > 0) {
            this.showContractsGraph = true;
            this.maxProcessDate = value[0].MaxProcessDate;
            this.lastFundingMod = moment(value[0].LastFundingModOverall).format(
                'MM/DD/YYYY'
            );
            if (value.length > 19) {
                this.highFundingDataCount = true;
            } else {
                this.highFundingDataCount = false;
            }
        }

        const desc = [];
        const contractSpent = [];
        const contractFunded = [];
        const contractValue: number[] = [];
        const spentBarColors: any[] = [];
        value.forEach(c => {
            if (
                this.contractFormGroup &&
                this.contractFormGroup.controls['toggle'].value == true
            ) {
                desc.push(c.ChargeNumber);
            } else {
                desc.push(c.ContractDesc);
            }
            if (c.Spent > c.Funded) {
                spentBarColors.push('#9A2A2A');
            } else {
                spentBarColors.push('#85BAA1');
            }
            contractSpent.push(c.Spent);
            contractFunded.push(c.Funded);
            contractValue.push(c.ContractValue);
        });
        const spentExceedsFundingIndexes = [];
        value.forEach(v => {
            if (v.Spent > v.Funded) {
                const index = value.findIndex(x => x == v);
                spentExceedsFundingIndexes.push(index);
            }
        });

        if (
            this.contractFormGroup &&
            this.contractFormGroup.controls['toggle'].value == true
        ) {
            this.fundingData = {
                labels: desc,
                datasets: [
                    {
                        categoryPercentage: 0.7,
                        barPercentage: 1,
                        type: 'bar',
                        label: 'Spent',
                        backgroundColor: spentBarColors, //'#85BAA1', //seafoam green
                        //backgroundColor: '#81A684', // light forrest green
                        //backgroundColor: '#6D9F71', // forrest green crayola
                        data: contractSpent //[650, 590, 800, 810, 560, 550, 400]
                    },
                    {
                        categoryPercentage: 0.7,
                        barPercentage: 1,
                        type: 'bar',
                        label: 'Funded',
                        //backgroundColor: '#6E8894', //dark slate blue
                        backgroundColor: '#57886C', //forrest green
                        //backgroundColor: '#337357', //amazon green
                        data: contractFunded //[980, 880, 1400, 1000, 860, 770, 900]
                    },
                    {
                        categoryPercentage: 0.7,
                        barPercentage: 1,
                        type: 'bar',
                        label: 'Over 100%',
                        backgroundColor: '#9A2A2A',
                        data: []
                    },
                ]
            };
        } else {
            this.fundingData = {
                labels: desc,
                datasets: [
                    {
                        stack: 1,
                        categoryPercentage: 0.7,
                        barPercentage: 1,
                        type: 'bar',
                        label: 'Spent',
                        //backgroundColor: '#B9C6AE',
                        backgroundColor: spentBarColors,//'#85BAA1', //seafoam green
                        //backgroundColor: '#81A684', // light forrest green
                        //backgroundColor: '#6D9F71', // forrest green crayola
                        //borderColor: '#81A684',
                        //borderWidth: 3,
                        data: contractSpent //[650, 590, 800, 810, 560, 550, 400]
                    },
                    {
                        stack: 2,
                        categoryPercentage: 0.7,
                        barPercentage: 1,
                        type: 'bar',
                        label: 'Funded',
                        //backgroundColor: '#8A95A5',
                        //backgroundColor: '#6E8894', //dark slate blue
                        backgroundColor: '#57886C', //forrest green
                        //backgroundColor: '#337357', //amazon green
                        //borderColor: '#57886C',
                        //borderWidth: 3,
                        data: contractFunded //[980, 880, 1400, 1000, 860, 770, 900]
                    },
                    {
                        stack: 3,
                        categoryPercentage: 0.7,
                        barPercentage: 1,
                        type: 'bar',
                        label: 'Awarded',
                        //backgroundColor: '#757083',
                        //backgroundColor: '#544E61', //dark slate purple
                        backgroundColor: '#466060', //dark forrest green
                        //backgroundColor: '#2E2D4D', //dark purple
                        //borderColor: '#757083',
                        //borderWidth: 3,
                        data: contractValue //[980, 880, 1400, 1000, 860, 770, 900]
                    },
                    {
                        categoryPercentage: 0.7,
                        barPercentage: 1,
                        type: 'bar',
                        label: 'Over 100%',
                        backgroundColor: '#9A2A2A',
                        data: []
                    },
                ]
            };
        }

        this.stackedOptions = {
            indexAxis: 'y',
            responsive: true,
            aspectRatio: desc.length > 19 ? 1 : 1 | 2,
            //maintainAspectRatio: false,
            plugins: {
                tooltips: {
                    mode: 'index',
                    intersect: false
                },
                legend: {
                    display: false,
                    labels: {
                        color: '#495057'
                    }
                }
                // zoom: {
                //     zoom: {
                //       wheel: {
                //         enabled: true,
                //       },
                //       pan: {
                //         enabled: true
                //       },
                //       pinch: {
                //         enabled: true
                //       },
                //       mode: 'y',
                //     }
                // }
            },
            layout: {
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                }
            },
            scales: {
                x: {
                    //stacked: true,
                    ticks: {
                        color: '#495057',
                        fontSize: 6,
                        callback: function (value, index, ticks) {
                            return '$' + value;
                        }
                    },
                    grid: {
                        color: '#ebedef'
                    },
                    suggestedMin: Math.min(...contractValue),
                    suggestedMax: Math.max(...contractValue)
                },
                y: {
                    //stacked: true,
                    ticks: {
                        color: '#495057',
                        fontSize: 6,
                        autoSkip: false
                    },
                    grid: {
                        color: '#ebedef'
                    },
                    suggestedMin: Math.min(...contractValue),
                    suggestedMax: Math.max(...contractValue)
                }
            }
        };
    }
    get funding(): Array<Funding> {
        return this._funding;
    }

    private DRStatusSubject = new ReplaySubject<Array<DRStatus>>(1);
    private _drstatus: Array<DRStatus>;
    @Input() set drStatus(value: Array<DRStatus>) {
        this._drstatus = value;
        this.DRStatusSubject.next(value);

        if (value && value.length > 0) {
            if (value.length > 19) {
                this.highPlannedHoursCount = true;
            } else {
                this.highPlannedHoursCount = false;
            }
            this.supervisorGraphTitle = 'Planned Hours Worked';
        } else {
            this.supervisorGraphTitle = 'No Planned Hours Found';
        }
        const desc = [];
        const hoursWorked = [];
        const hoursPlanned = [];
        const percentWorked = [];
        const hrsWorkedColors = [];
        value.forEach(c => {
            desc.push(c.Name_Task);
            hoursWorked.push(c.HrsWorked);
            hoursPlanned.push(c.HrsPlanned);
            percentWorked.push(c.PercentWorked);

            if (c.HrsWorked > c.HrsPlanned) {
                hrsWorkedColors.push('#9A2A2A');
            } else {
                hrsWorkedColors.push('#337ab7');
            }
        });
        this.usersData = {
            labels: desc,
            datasets: [
                {
                    categoryPercentage: 0.7,
                    barPercentage: 1,
                    type: 'bar',
                    label: 'Worked',
                    backgroundColor: hrsWorkedColors,//'#337ab7',
                    //backgroundColor: '#42A5F5',
                    //backgroundColor: '#AFBFC0',
                    data: hoursWorked
                },
                {
                    categoryPercentage: 0.7,
                    barPercentage: 1,
                    type: 'bar',
                    label: 'Planned',
                    backgroundColor: '#1e3c72',
                    //backgroundColor: '#847E89',
                    data: hoursPlanned
                },
                {
                    categoryPercentage: 0.0,
                    barPercentage: 0,
                    type: 'bar',
                    label: 'Over Worked',
                    backgroundColor: '#9A2A2A',
                    data: []
                }
            ]
        };

        this.supStackedOptions = {
            indexAxis: 'y',
            responsive: true,
            aspectRatio: desc.length > 19 ? 1 : 1 | 2,
            plugins: {
                tooltips: {
                    mode: 'index',
                    intersect: false
                },
                legend: {
                    display: false,
                    labels: {
                        color: '#495057'
                    }
                }
                // zoom: {
                //     zoom: {
                //       wheel: {
                //         enabled: true,
                //       },
                //       pinch: {
                //         enabled: true
                //       },
                //       mode: 'y',
                //     }
                // }
            },
            layout: {
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                }
            },
            scales: {
                x: {
                    //stacked: true,
                    ticks: {
                        color: '#495057',
                        fontSize: 6
                    },
                    grid: {
                        color: '#ebedef'
                    },
                    suggestedMin: Math.min(...hoursPlanned),
                    suggestedMax: Math.max(...hoursPlanned)
                },
                y: {
                    //stacked: true,
                    ticks: {
                        color: '#495057',
                        fontSize: 6,
                        autoSkip: false
                    },
                    grid: {
                        color: '#ebedef'
                    },
                    suggestedMin: Math.min(...hoursPlanned),
                    suggestedMax: Math.max(...hoursPlanned)
                }
            }
        };
    }
    get drStatus(): Array<DRStatus> {
        return this._drstatus;
    }

    private AccrualDataSubject = new ReplaySubject<Array<Accrual>>(1);
    private _accrualdata: Array<Accrual>;
    @Input() set accrualData(value: Array<Accrual>) {
        this._accrualdata = value;
        this.AccrualDataSubject.next(value);

        if (value.length == 0) {
            this.showAccrualGraphs = false;
        }

        if (value && value.length > 0) {
            this.showAccrualGraphs = true;
            const desc = [];
            const availableHours = [];
            const plannedHours = [];
            value.forEach(c => {
                if (c && c.PPE) {
                    desc.push(moment(c.PPE).format('MM/DD'));
                    if (
                        new Date(c.PPE) >
                        new Date(this.user.userInfo.PrevPayPeriodEnd)
                    ) {
                        availableHours.push(null);
                    } else {
                        availableHours.push(c.PPEAvailableVacHrs);
                    }
                    if (
                        new Date(c.PPE) <
                        new Date(this.user.userInfo.PrevPayPeriodEnd)
                    ) {
                        plannedHours.push(null);
                    } else {
                        plannedHours.push(c.PPEAvailable_PlannedVacHrs);
                    }
                }

            });
            this.accrualChartData = {
                labels: desc,
                datasets: [
                    {
                        label: 'Available',
                        data: availableHours,
                        fill: false,
                        tension: 0.4,
                        borderColor: '#42A5F5'
                    },
                    {
                        label: 'Planned',
                        data: plannedHours,
                        fill: false,
                        borderDash: [5, 5],
                        tension: 0.4,
                        borderColor: '#66BB6A'
                    }
                ]
            };

            this.accrualChartOptions = {
                responsive: true,
                aspectRatio: 1 | 2,
                plugins: {
                    legend: {
                        labels: {
                            color: '#495057'
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef'
                        }
                    },
                    y: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef'
                        }
                    }
                }
            };
        }
    }
    get accrualData(): Array<Accrual> {
        return this._accrualdata;
    }

    showContractsGraph = true;
    showAccrualGraphs = true;
    showDashboardSettings = false;
    items: MenuItem[];
    usersData: any;
    fundingData: any;
    basicData: any;
    accrualChartData: any;
    stackedOptions: any;
    accrualChartOptions: any;
    supStackedOptions: any;
    active = true;
    usersSelectItem: SelectItem[];
    contractsSelectItem: SelectItem[];
    periodsSelectItem: SelectItem[];
    selectedContracts: any[] = [];
    contractFormGroup: UntypedFormGroup;
    supGraphFormGroup: UntypedFormGroup;

    //@Input() contracts: Contract[];
    @Input() companySettings: CompanySetting[];
    @Input() roleID: number;
    @Input() processes: Process[];
    @Input() showSupervisorStatusBlock: boolean;
    @Input() showPMStatusBlock: boolean;
    @Input() selectedProcesses: Process[];

    //colHeaders: any[];
    settingsData: any[];

    contractFunding: Funding[] = [];

    @Output() GetAccrualData = new ReplaySubject<any>(1);
    @Output() GetFunding = new ReplaySubject<any>(1);
    @Output() GetDRStatus = new ReplaySubject<any>(1);
    @Output() GetDirectReports = new ReplaySubject<any>(1);
    @Output() markAsRead = new ReplaySubject<any>(1);
    @Output() UpdateDashboardSettings = new ReplaySubject<any>(1);

    messages: any[] = [];
    messageCount = 0;

    showMessageBlock = false;

    chartTypes: any[];

    periodStart: any;
    periodEnd: any;
    chartType: number;

    maxProcessDate: string;

    supervisorGraphTitle: string;

    contractsAndFundingProcess: Process;

    highFundingDataCount: boolean;
    admin: boolean;

    auths: Process;

    lastFundingMod: string;

    testTableData: any;

    Object: any;

    colSpan: any;

    rows: any;

    colGroupNames: any;

    colHeaders: any = [];

    rowCells: any = [];
    rowCellsForcast: any = [];

    helpdeskVideoMP4 = '/videos/helpdesk.mp4';

    showVideo = false;

    filteredCategories$ = this.categoryService.filteredCategories$;

    constructor(
        public app: AppComponent,
        private log: LoggingService,
        public messageStateService: MessageStateService,
        private categoryService: CategoryService
    ) {
        Chart.register(zoomPlugin);
        this.Object = Object;
    }

    ngOnInit() {
        this.contractFormGroup = new UntypedFormGroup({
            MultiContract: new UntypedFormControl(null),
            Contract: new UntypedFormControl(null),
            toggle: new UntypedFormControl(null),
            percentSpent: new UntypedFormControl(null)
        });
        this.supGraphFormGroup = new UntypedFormGroup({
            drOnly: new UntypedFormControl(null),
            percent: new UntypedFormControl(null),
            period: new UntypedFormControl(null),
            users: new UntypedFormControl(null),
            user: new UntypedFormControl(null),
            tasktoggle: new UntypedFormControl(null)
        });

        this.GetAccrualData.next();

        this.setupSubscriptions();

        // Initialize the message state service with user settings
        if (this.user && this.user.userInfo && this.user.userInfo.EmployeeListID) {
            this.messageStateService.initializeFromStore(this.user.userInfo.EmployeeListID);
        }

        if (this.processes) {
            if (this.processes.findIndex(x => x.ProcessID == 13) != -1) {
                this.contractsAndFundingProcess = this.processes.find(
                    x => x.ProcessID == 13
                );
            }

            if (this.processes.findIndex(x => x.ProcessID == 2) != -1) {
                this.auths = this.processes.find(x => x.ProcessID == 2);
            }
        }

        // if (this.processes && this.userRoles && this.user) {
        //     const home = {
        //         ProcessID: 0,
        //         ProcessName: 'Main',
        //         RouteName: 'Main',
        //         ProcessDesc: '',
        //         ProcessTitle: 'Home',
        //         MsgCount: null
        //     };
        //     if (
        //         this.userRoles.findIndex(x => x.RoleGroupID == 1) != -1 &&
        //         this.user.userInfo.DefaultRoleGroupID == 1
        //     ) {
        //         this.selectedProcesses.push(home);
        //         const checkup = this.processes.find(x => x.ProcessID == 145);
        //         this.selectedProcesses.push(checkup);

        //         const allUsers = this.processes.find(x => x.ProcessID == 14);
        //         this.selectedProcesses.push(allUsers);

        //         const timeentry = this.processes.find(x => x.ProcessID == 64);
        //         this.selectedProcesses.push(timeentry);

        //         // var contractsandfunding = this.processes.find(x => x.ProcessID == 13);
        //         // this.selectedProcesses.push(contractsandfunding);

        //         const auths = this.processes.find(x => x.ProcessID == 2);
        //         this.selectedProcesses.push(auths);

        //         if (this.processes.findIndex(x => x.ProcessID == 85) != -1) {
        //             const timeapproval = this.processes.find(
        //                 x => x.ProcessID == 85
        //             );
        //             this.selectedProcesses.push(timeapproval);
        //         }
        //     } else if (
        //         this.userRoles.findIndex(x => x.RoleGroupID == 12024) != -1 &&
        //         this.user.userInfo.DefaultRoleGroupID == 12024
        //     ) {
        //         this.selectedProcesses.push(home);
        //         const timeentry = this.processes.find(x => x.ProcessID == 64);
        //         this.selectedProcesses.push(timeentry);

        //         const timeapproval = this.processes.find(
        //             x => x.ProcessID == 85
        //         );
        //         this.selectedProcesses.push(timeapproval);

        //         if (this.processes.findIndex(x => x.ProcessID == 86) != -1) {
        //             const expapproval = this.processes.find(
        //                 x => x.ProcessID == 86
        //             );
        //             this.selectedProcesses.push(expapproval);
        //         }

        //         if (this.processes.findIndex(x => x.ProcessID == 2) != -1) {
        //             const auths = this.processes.find(x => x.ProcessID == 2);
        //             this.selectedProcesses.push(auths);
        //         }
        //     } else if (
        //         this.userRoles.findIndex(x => x.RoleGroupID == 12025) != -1 &&
        //         this.user.userInfo.DefaultRoleGroupID == 12025
        //     ) {
        //         this.selectedProcesses.push(home);
        //         const timeentry = this.processes.find(x => x.ProcessID == 64);
        //         this.selectedProcesses.push(timeentry);

        //         const timevalidate = this.processes.find(
        //             x => x.ProcessID == 87
        //         );
        //         this.selectedProcesses.push(timevalidate);

        //         if (this.processes.findIndex(x => x.ProcessID == 88) != -1) {
        //             const expvalidate = this.processes.find(
        //                 x => x.ProcessID == 88
        //             );
        //             this.selectedProcesses.push(expvalidate);
        //         }
        //     } else {
        //         this.selectedProcesses.push(home);
        //         const timeentry = this.processes.find(x => x.ProcessID == 64);
        //         this.selectedProcesses.push(timeentry);

        //         if (this.processes.findIndex(x => x.ProcessID == 70) != -1) {
        //             const expentry = this.processes.find(
        //                 x => x.ProcessID == 70
        //             );
        //             this.selectedProcesses.push(expentry);
        //         }

        //         if (this.processes.findIndex(x => x.ProcessID == 69) != -1) {
        //             const leave = this.processes.find(x => x.ProcessID == 69);
        //             this.selectedProcesses.push(leave);
        //         }
        //     }
        // }

        this.contractFormGroup.controls['toggle'].patchValue(false);
        this.supGraphFormGroup.controls['tasktoggle'].patchValue(false);

        this.chartTypes = [
            { label: 'Over 50%', value: '50' },
            { label: 'Over 75%', value: '75' }
        ];
        this.contractChartTypes = [
            { label: 'Any % Spent', value: '0' },
            { label: 'Over 50% Spent', value: '50' },
            { label: 'Over 75% Spent', value: '75' }
        ];
        this.supGraphFormGroup.controls['percent'].patchValue(
            this.chartTypes[1].value
        );
        // this.contractFormGroup.controls['percentSpent'].patchValue(
        //     this.contractChartTypes[0].value
        // );

        // if (this.contracts) {
        //     this.contractsSelectItem = this.contracts.map(x => ({
        //         label: x.ContractDesc,
        //         value: x.ContractListID
        //     }));
        //     const initialContractsForChart = [];
        //     let numOfDefaultContracts;
        //     if (this.contractsSelectItem.length > 10) {
        //         numOfDefaultContracts = 10;
        //     } else {
        //         numOfDefaultContracts = this.contractsSelectItem.length;
        //     }
        //     for (let i = 0; i < numOfDefaultContracts; i++) {
        //         initialContractsForChart.push(
        //             this.contractsSelectItem[i].value
        //         );
        //     }
        //     this.contractFormGroup.controls['MultiContract'].patchValue(
        //         initialContractsForChart
        //     );
        // }
        // this.colHeaders = [
        //     {
        //         label: 'Setting'
        //     },
        //     {
        //         label: 'Value'
        //     }
        // ];
        this.settingsData = [
            {
                Setting: 'Quick Access'
            }
        ];

        this.periodsSelectItem = [
            {
                label: 'Current',
                value: 0
            },
            {
                label: 'Previous',
                value: 1
            },
            {
                label: 'Past 90 days',
                value: 2
            }
        ];
        //this.shopifyBuyButtonInit();
    }

    ngOnDestroy() {
        this.active = false;
    }

    setupSubscriptions() {
        this.contractFormGroup.controls['MultiContract'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null && value.length > 0) {
                    const LIMIT_NUMBER = 100;
                    if (
                        value.length > LIMIT_NUMBER &&
                        this.selectedContracts.length != 100
                    ) {
                        value.splice(LIMIT_NUMBER, value.length - LIMIT_NUMBER);
                    } else {
                        if (this.selectedContracts.length == 100) {
                            value.splice(0, value.length);
                        }
                    }
                    let listIDString = value[0];
                    value.forEach(c => {
                        if (c != value[0]) {
                            listIDString = `${listIDString},${c}`;
                        }
                    });
                    this.contractFormGroup.controls['percentSpent'].reset();
                    this.GetFunding.next(
                        `?ContractListID=${listIDString}&FundingDetail=false&PercentSpent=0`
                    );

                    listIDString = null;
                } else {
                    this.fundingData = null;
                }
            });
        this.contractFormGroup.controls['Contract'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(c => {
                if (c != null) {
                    this.contractFormGroup.controls['percentSpent'].enable();
                    this.GetFunding.next(
                        `?ContractListID=${c}&FundingDetail=true`
                    );
                }
            });
        this.contractFormGroup.controls['toggle'].valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(value => {
                if (value != null) {
                    if (
                        value == true &&
                        this.contractFormGroup.controls['Contract'].value ==
                            null
                    ) {
                        this.contractFormGroup.controls['percentSpent'].reset();
                        this.contractFormGroup.controls[
                            'percentSpent'
                        ].disable();
                    }
                    if (
                        value == false &&
                        this.contractFormGroup.controls['Contract'].value !=
                            null
                    ) {
                        this.contractFormGroup.controls[
                            'MultiContract'
                        ].patchValue([
                            this.contractFormGroup.controls['Contract'].value
                        ]);
                    }
                    if (
                        value == true &&
                        this.contractFormGroup.controls['MultiContract']
                            .value != null
                    ) {
                        this.contractFormGroup.controls['Contract'].patchValue(
                            this.contractFormGroup.controls['MultiContract']
                                .value[0]
                        );
                    }
                }
            });
        this.contractFormGroup.controls['percentSpent'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.contractFormGroup.controls['MultiContract'].reset();
                    if (
                        this.processes.findIndex(x => x.ProcessID == 13) != -1
                    ) {
                        if (
                            this.contractFormGroup.controls['toggle'].value ==
                            true
                        ) {
                            this.GetFunding.next(
                                `?ContractListID=${this.contractFormGroup.controls['Contract'].value}&FundingDetail=${this.contractFormGroup.controls['toggle'].value}&PercentSpent=${value}`
                            );
                        } else {
                            if (
                                this.contractFormGroup.controls['MultiContract']
                                    .value != null
                            ) {
                                this.GetFunding.next(
                                    `?ContractListID=${this.contractFormGroup.controls['MultiContract'].value}&FundingDetail=${this.contractFormGroup.controls['toggle'].value}&PercentSpent=${value}`
                                );
                            } else {
                                this.GetFunding.next(
                                    `?FundingDetail=${this.contractFormGroup.controls['toggle'].value}&PercentSpent=${value}`
                                );
                            }
                        }
                    }
                }
            });

        this.supGraphFormGroup.controls['drOnly'].valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(value => {
                this.GetDirectReports.next({
                    user: this.user.userInfo,
                    activeOnly: true,
                    MyDRsOnly: value
                });
                this.supGraphFormGroup.controls['users'].reset();
                this.supGraphFormGroup.controls['user'].reset();
            });

        this.supGraphFormGroup.controls['percent'].valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(value => {
                if (value != null) {
                    if (value == '75') {
                        this.chartType = 75;
                    } else {
                        this.chartType = 50;
                    }
                    this.supGraphFormGroup.controls['users'].reset();
                    if (
                        this.userRoles.findIndex(x => x.RoleGroupID == 1) !=
                            -1 ||
                        this.userRoles.findIndex(x => x.RoleGroupID == 12024) !=
                            -1
                    ) {
                        if (
                            this.supGraphFormGroup.controls['user'].value !=
                            null
                        ) {
                            this.GetDRStatus.next(
                                `?EmployeeListID=${this.supGraphFormGroup.controls['user'].value}&PercentWorked=${this.chartType}&IncludeTasks=${this.supGraphFormGroup.controls['tasktoggle'].value}`
                            );
                        } else {
                            this.GetDRStatus.next(
                                `?EmployeeListID=&PercentWorked=${this.chartType}&IncludeTasks=${this.supGraphFormGroup.controls['tasktoggle'].value}`
                            );
                        }
                    } else {
                        this.GetDRStatus.next(
                            `?EmployeeListID=${this.user.userInfo.EmployeeListID}&PercentWorked=${this.chartType}&IncludeTasks=true`
                        );
                    }
                }
            });
        this.supGraphFormGroup.controls['user'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(u => {
                if (u != null) {
                    this.supGraphFormGroup.controls['percent'].reset();
                    this.supGraphFormGroup.controls['percent'].enable();
                    this.GetDRStatus.next(
                        `?EmployeeListID=${u}&PercentWorked=0&IncludeTasks=true`
                    );
                }
            });
        this.supGraphFormGroup.controls['users'].valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(value => {
                if (value != null && value.length > 0) {
                    const LIMIT_NUMBER = 100;
                    if (value.length > LIMIT_NUMBER) {
                        value.splice(LIMIT_NUMBER, value.length - LIMIT_NUMBER);
                    }
                    let listIDString = value[0];
                    value.forEach(c => {
                        if (c != value[0]) {
                            listIDString = `${listIDString},${c}`;
                        }
                    });

                    this.GetDRStatus.next(
                        `?EmployeeListID=${listIDString}&PercentWorked=0&IncludeTasks=${this.supGraphFormGroup.controls['tasktoggle'].value}`
                    );
                    listIDString = null;
                    this.supGraphFormGroup.controls['percent'].reset();
                    this.supGraphFormGroup.controls['percent'].enable();
                } else {
                    this.usersData = null;
                }
            });
        this.supGraphFormGroup.controls['tasktoggle'].valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.supGraphFormGroup.controls['user'].reset();
                    this.supGraphFormGroup.controls['percent'].reset();
                    if (
                        value == true &&
                        this.supGraphFormGroup.controls['user'].value == null
                    ) {
                        this.supGraphFormGroup.controls['percent'].disable();
                    }
                    if (value == false) {
                        this.supGraphFormGroup.controls['percent'].patchValue(
                            '75'
                        );
                    }

                    // if (
                    //     value == false &&
                    //     this.supGraphFormGroup.controls['user'].value != null
                    // ) {
                    //     this.supGraphFormGroup.controls['users'].patchValue([
                    //         this.supGraphFormGroup.controls['user'].value
                    //     ]);
                    // }
                    if (
                        value == true &&
                        this.supGraphFormGroup.controls['users'].value != null
                    ) {
                        this.supGraphFormGroup.controls['user'].patchValue(
                            this.supGraphFormGroup.controls['users'].value[0]
                        );
                    }
                    if (value == false) {
                        this.supGraphFormGroup.controls['percent'].enable();
                    }
                }
            });
    }

    openDashboardSettings() {
        this.dashboardSettingsTableData =
            this.dashboardSettings != null ? this.dashboardSettings : [];
        this.showDashboardSettings = true;
    }

    openMessages() {
        this.showMessageBlock = true;
    }

    quickAccessChange($event) {
        this.log.verbose($event);
    }

    onChangeContracts($event) {
        this.selectedContracts = $event.value;
    }

    updateSettingCheckboxChecked($event, row) {
        const item = {
            DashboardItemID: row.DashboardItemID,
            IsVisible: $event.checked
        };
        this.UpdateDashboardSettings.next(item);
    }

    onMarkAsReadChanged($event) {
        // Use the message state service to update the setting
        this.messageStateService.setMarkAsRead($event.checked, this.user.userInfo.EmployeeListID);
    }

    // updateDashboardDesc(row) {
    //     var item = {
    //         DashboardItemID: row.DashboardItemID,
    //         DashboardItemDesc: row.DashboardItemDesc,
    //         IsVisible: true
    //     };
    //     this.UpdateDashboardSettings.next(item);
    // }

    // shopifyBuyButtonInit() {
    //     const client = ShopifyBuy.buildClient({
    //         domain: 'efaacttest.myshopify.com',
    //         storefrontAccessToken: '107cd7ce438e09df0d0dbda6d8fafb27',
    //     });
    //     const ui = ShopifyBuy.UI.init(client);

    //     ui.createComponent('product', {
    //         id: '7315301990578',
    //         node: document.getElementById('product-component-1667495584882'),
    //         options: {
    //             "product": {
    //               "styles": {

    //                 "title": {
    //                   "font-size": "12px"
    //                 }
    //               }
    //             }
    //         }
    //     });

    //     ui.createComponent('product', {
    //         id: '7329103347890',
    //         node: document.getElementById('product-component-1667502701454'),
    //         options: {
    //             "product": {
    //               "styles": {

    //                 "title": {
    //                   "font-size": "12px"
    //                 }
    //               }
    //             }
    //         }
    //     });
    // }
}
